<canvas
  baseChart
  [labels]="labels"
  [datasets]="doughnutChartDatasets"
  [options]="doughnutChartOptions"
  [legend]="true"
  [type]="'doughnut'"
  [width]="chartWidth()"
>
</canvas>
